import "../assets/css/news.css";
import { useState, useEffect } from "react";
import { Loading } from "../components/loading";
import { PopupDialog } from "../components/popupDialog";

export const News = ({ news, isShowSectionTitle = true }) => {
  const [open, setOpen] = useState(false);
  const [selectedNews, setSelectedNews] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 5;
  const startIndex = currentPage * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const displayedNews = news.slice(startIndex, endIndex);
  const handleMoreInfo = (newsItem) => {
    setSelectedNews(newsItem);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setSelectedNews(null);
  };
  const handleNext = () => {
    if ((currentPage + 1) * itemsPerPage < news.length) {
      setCurrentPage((prev) => prev + 1);
    }
  };
  const handlePrev = () => {
    if (currentPage > 0) {
      setCurrentPage((prev) => prev - 1);
    }
  };
  useEffect(() => {
    if (news && news.length > 0) {
      setLoading(false);
    }
  }, [news, isShowSectionTitle]);

  return (
    <section id="news">
      {loading ? (
        <Loading />
      ) : (
        <div className="news-container">
          {isShowSectionTitle && (
            <div>
              <h3>NEWS</h3>
              <hr />
            </div>
          )}
          <div className="news-content">
            {displayedNews.map((newsItem, index) => (
              <div className="box-container" key={index}>
                <div className="news-row">
                  <label className="news-date">
                    {newsItem.lastModifiedDate}
                  </label>
                  <label
                    className="more-info"
                    onClick={() => handleMoreInfo(newsItem)}
                  >
                    MORE INFO
                  </label>
                  <label>{newsItem.title}</label>
                </div>
                <hr />
              </div>
            ))}
          </div>
          <div>
            {currentPage > 0 && (
              <button className="prev-button" onClick={handlePrev}>
                Previous
              </button>
            )}
            {endIndex < news.length && (
              <button className="next-button" onClick={handleNext}>
                Next
              </button>
            )}
          </div>
          <PopupDialog
            name="newsPopup"
            open={open}
            onClose={handleClose}
            title={selectedNews?.title}
            content={
              <div className="rich-text-preview-div">
                <div
                  className="rich-text-preview-inner-div"
                  dangerouslySetInnerHTML={{
                    __html: selectedNews?.info,
                  }}
                />
              </div>
            }
          />
        </div>
      )}
    </section>
  );
};
